import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import {
    Box,
    Flex,
    Heading,
} from '@chakra-ui/react';
import CtaButton from '../CtaButton/CtaButton';
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'

const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      gap: 0
      //slidesToSlide: 4 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };

export default function NewsCarousel({ slice }) {

    const carouselItems = slice.items; 
    console.log(carouselItems);
    
    return (
        <Box>
            <Box h="4" bg="sage.600" />
            <Carousel 
                swipeable={true}
                responsive={responsive}
                ssr={true}
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={4000}
                centerMode={false}
                //showDots
                //renderDotsOutside={false}
                containerClass="carousel-container"
                //removeArrowOnDeviceType={["tablet", "mobile", "desktop"]} 
            >
                {carouselItems.map((item, index) => (
                    <>
                        <Box key={index} h="100%">
                            <Flex bg="sage.500" w="100%" h="100%" flexWrap="wrap">
                                <Box w={{base: '100%', md: '50%'}} p="12" >
                                    <Flex flexDirection="column" height="100%" justifyContent="center" margin="auto" pl={{base: "0", md: "12"}}>
                                        <Box mb="2" pl="2">
                                            <Heading as="h3" variant="h3" color="white" fontWeight="700" fontSize={["4xl", "4xl", "4xl", "6xl"]} textAlign={{base: 'center', md:'left'}}>
                                               {item.title}
                                            </Heading>
                                        </Box>
                                        <Box color="white" fontSize={{base: "1.125rem", md: "1.5rem", lg: "2rem"}} fontWeight="500" textAlign={{base: 'center', md:'left'}} mb="4" pl="2">
                                            {item.excerpt}
                                        </Box>
                                        {item.button_label && 
                                        <Box pl="2" textAlign={{base: 'center', md:'left'}}>
                                        <CtaButton 
                                            variant="Yellow"
                                            size={["md", "lg"]}
                                            linkTo={item.button_link.url}
                                            buttonLabel={item.button_label}
                                        />
                                        </Box>}
                                    </Flex>
                                </Box>
                                <Box w={{base: '100%', md: '50%'}} display={{base: 'none', md: 'block'}} pr="16">
                                    <Flex h="100%" w="100%" alignItems="center">
                                        <Box className='news-carousel-image-box' w="100%">
                                            <GatsbyImage image={getImage(item.image.localFile)} imgStyle={{height: 'auto'}} />
                                        </Box>
                                    </Flex>
                                </Box>
                            </Flex>
                            
                        </Box>
                        </>
                ))}
            </Carousel>
            <Box h="4" bg="sage.600" />
        </Box>
    )
}